import { DIRECTOR } from "@/data/content";
import { Briefcase } from "@phosphor-icons/react";

export const Leadership = () => {
  return (
    <section id="leadership" data-testid="leadership-section" className="py-24 lg:py-32 bg-[#FAFAFA] border-t border-slate-200">
      <div className="mx-auto max-w-7xl px-6 lg:px-10 grid lg:grid-cols-12 gap-14 items-start">
        <div className="lg:col-span-5">
          <span className="overline text-[#B91C1C]">Leadership</span>
          <h2 className="mt-4 font-serif-display text-3xl lg:text-4xl font-bold tracking-tight text-slate-900">
            {DIRECTOR.name}
          </h2>
          <p className="mt-2 text-sm text-slate-500">{DIRECTOR.role}</p>
          <div className="mt-8 border border-slate-200 bg-white p-8">
            <Briefcase weight="duotone" className="h-10 w-10 text-slate-900" />
            <p className="mt-4 font-serif-display text-4xl font-bold text-slate-900">21+ years</p>
            <p className="text-sm text-slate-500 mt-1">in collections & risk management</p>
          </div>
        </div>

        <div className="lg:col-span-7">
          <p className="text-lg text-slate-700 leading-relaxed">{DIRECTOR.bio}</p>

          <div className="mt-10">
            <p className="overline text-slate-500 mb-4">Institutions led</p>
            <div className="flex flex-wrap gap-3">
              {DIRECTOR.brands.map((b) => (
                <span key={b} className="border border-slate-300 px-4 py-2 text-sm font-medium text-slate-800">{b}</span>
              ))}
            </div>
          </div>

          <div className="mt-10">
            <p className="overline text-slate-500 mb-4">Portfolios managed</p>
            <div className="grid grid-cols-2 sm:grid-cols-3 border-t border-l border-slate-200">
              {DIRECTOR.portfolios.map((p) => (
                <div key={p} className="border-r border-b border-slate-200 px-5 py-4 text-sm text-slate-700 bg-white">{p}</div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
